import { useMutation, useQueryClient } from "react-query";
import http from "infra/http";
import { useCurrentTenant } from "core/features/auth/tenant.store";
import { TenantContaResponse } from "../typings";

function useCreateContaBancaria(tenantId?: string) {
  const queryClient = useQueryClient();
  const { tenant } = useCurrentTenant();
  const _tenantId = tenantId || tenant.id;
  const apiRoute = `/v1/tenants/${_tenantId}/conta-bancaria`;

  return useMutation(
    apiRoute,
    (data: TenantContaResponse) => {
      if (data.id) {
        return http.put(`${apiRoute}/${data.id}`, data, { params: _tenantId });
      }
      return http.post(apiRoute, data, { params: _tenantId });
    },
    {
      retry: false,
      onSuccess: () => {
        queryClient.invalidateQueries(apiRoute);
      },
    }
  );
}

export default useCreateContaBancaria;
